import { apiGet, apiPost, apiPut } from './api'

export const getUserData = () => {
  return apiGet('api/v1/reimbursement-accounts/me')
}

export const upDateUserData = (body) => {
  return apiPut('api/v1/reimbursement-accounts/me', body)
}
export const emailVerification = (body) => {
  return apiPost('api/v1/reimbursement-accounts/me/email-verification', body)
}
export const getReimbursements = (ref) => {
  return apiGet(`api/v1/reimbursements/${ref}`)
}

export const upDateUserPassword = (body) => {
  return apiPut('api/v1/reimbursement-accounts/me/change-password', body)
}
export const resendEmailCode = (body) => {
  return apiPost('api/v1/reimbursement-accounts/forgot-password', body)
}
export const upDateEmail = (ref, body) => {
  return apiPut(`api/v1/reimbursements/${ref}/email`, body)
}
